import { Record } from 'immutable'

export interface ISocialNetwork {
  readonly id: string
  readonly name: string
  readonly icon: string
  readonly urlPattern: string
  readonly mobilePattern: string
}

const SocialNetworkRecord = Record({
  icon: '',
  id: '',
  mobilePattern: '',
  name: '',
  urlPattern: '',
})

export class SocialNetwork extends SocialNetworkRecord
  implements ISocialNetwork {
  public static fromJS(initialState?: Partial<ISocialNetwork>) {
    return new SocialNetwork(initialState)
  }

  public readonly id: string
  public readonly name: string
  public readonly icon: string
  public readonly urlPattern: string
  public readonly mobilePattern: string

  constructor(initialState?: Partial<SocialNetwork>) {
    initialState ? super(initialState) : super()
  }
}
